import { useId, } from "react";
import { SvgIconBase, } from "./Base";


export const CheckCircle = (props: React.ComponentProps<typeof SvgIconBase>) => {
	const maskId = useId();
	return (
		<SvgIconBase {...props} width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-label="Check Circle" fill="currentColor">
			<title>Check Circle</title>
			<defs>
				<mask id={maskId}>
					<rect width="16" height="16" fill="white" />
					<path d="M5 8.5L7 10.5L11 6" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
				</mask>
			</defs>
			<circle cx="8" cy="8" r="7.5" fill="currentColor" mask={`url(#${maskId})`} />
		</SvgIconBase>
	);
};



